import { Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { CheckRideTestTypeAllItems, PilotExaminerLocationEntity, PilotExaminerSearchQueryEntity } from '../../../../meta-data/app-meta-data.service';
import { DwUIConfigToken, DwUIConfig, DwConfigServiceToken, DwConfigService } from '@devwareapps/devware-cap';
import { ExaminerTimeSlotGrouping, ExaminterTimeSlotItem } from '../../../examiner/models/examiner-time-slot-grouping.model';
import { ExaminerLocationDetail, ExaminerLocationSelection } from '../../../examiner/models/exminer-location-selection.model';
import { ExaminerTimeSlotEntityExt, PilotExaminerSearchQueryEntityExt } from '../../../../meta-data/extensions/pilot-examiner-search-query-ext.model';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
// import { CheckrideVariables } from '../../../applicant/models/checkride-variables.model';
import { ScheduleSelectorService } from '../../services/schedule-selector.service';
import { Subscription } from 'rxjs';
import { ExaminerBookingVariableContext } from '../../models/examiner-booking-variable-context.model';

@Component({
  selector: 'app-examiner-booking-search-result',
  templateUrl: './examiner-booking-search-result.component.html',
  styleUrls: ['./examiner-booking-search-result.component.scss']
})
export class ExaminerBookingSearchResultComponent implements OnInit, OnChanges, OnDestroy {
  @Input() searchResult: PilotExaminerSearchQueryEntityExt;
  apiRoot: string;
  defaultAvatarMediaUrl: string;
  imagePath: string;

  selectedDateTime: string;
  selectedDateTimes: string[] = [];

  showConfirmButton: boolean = false;

  allowMultipleSelect: boolean = false;

  hideSection: boolean = false;
  @Input() showDateSelection: boolean = true;

  @Input() index: number;
  //@Input() examinerLocationSelection: ExaminerLocationSelection;


  //@Output() examinerLocationSelectionChange = new EventEmitter<ExaminerLocationSelection>();


  @Input() applicantCheckrideVariables: ExaminerBookingVariableContext;
  fullCheckrideCost: number;
  checkrideCost: number;

  @Input() testType: CheckRideTestTypeAllItems;
  checkrideDuration: number;
  checkrideDurationDisplay: string;
  totalAllowed: number;
  lastSelectedDateTime: string;
  subscriptions: Subscription[] = [];

  constructor(@Inject(DwUIConfigToken) private uiConfig: DwUIConfig,
    @Inject(DwConfigServiceToken) private dwConfigService: DwConfigService,
    private examinerRepositoryService: ExaminerRepositoryService,
    private dateTimeUtilService: DateTimeUtilService,
    private scheduleSelectorService: ScheduleSelectorService

  ) {
    this.apiRoot = dwConfigService.coreConfig.apiRoot;
  }
  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.setupImage();

    this.setupData();

    this.subscriptions.push(
      this.scheduleSelectorService.countChange.subscribe(() => {
        this.setupTotalAllowed();
      }));

    this.subscriptions.push(
      this.scheduleSelectorService.selectionChange.subscribe(() => {
        this.setupTotalAllowed();
        this.setupConfirmButton();
      }));
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.setupImage();

    this.setupInitialSelections();

    if (changes.searchResult || changes.testType) {
      this.setupData();
    }
  }

  setupData() {
    if (!this.searchResult) {
      return;
    }

    this.checkrideCost = this.examinerRepositoryService.getFullBookingCost(this.searchResult, this.testType, this.applicantCheckrideVariables);
    const checkrideDurationMinutes = this.examinerRepositoryService.getCheckrideTimeMinutes(this.searchResult, this.testType)
    this.checkrideDurationDisplay = this.dateTimeUtilService.formatDuration2(checkrideDurationMinutes * 60);

    this.fullCheckrideCost = this.checkrideCost + this.searchResult.PilotExaminerLocationTravelCost || 0;
  }

  setSelectedDateTime(selectedDateTime: string) {
    if (!this.isContainerSelected()) {
      // Store date for later use
      this.lastSelectedDateTime = selectedDateTime;
      return;
    }
    if (this.totalAllowed == 0) {
      this.selectedDateTime = null;
      this.selectedDateTimes = [];
      return;
    }

    this.selectedDateTime = selectedDateTime;

    this.selectedDateTimes = [selectedDateTime];

    this.setSelectedDateTimes([selectedDateTime]);

    // this.scheduleSelectorService.setDates(this.index, [selectedDateTime]);


    // this.setupConfirmButton();
  }

  setSelectedDateTimes(selectedDateTimes: string[]) {

    if (selectedDateTimes.length > this.totalAllowed) {
      selectedDateTimes = selectedDateTimes.slice(0, this.totalAllowed);
    }

    this.scheduleSelectorService.setDates(this.index, selectedDateTimes);

    this.setupConfirmButton();
  }

  private setupConfirmButton() {
    this.showConfirmButton = this.scheduleSelectorService.showConfirmButton(this.index);

    // if (this.scheduleSelectorService.showConfirmButton(this.index)) {
    // if (this.examinerLocationDetail?.scheduleDateTime?.length > 0) {
    //   this.showConfirmButton = true;
    // }
  }

  confirmSelection() {
    // this.examinerLocationSelection.confirmed = true;
    this.scheduleSelectorService.confirmSelection(this.index);
  }

  isContainerSelected() {
    return this.scheduleSelectorService.isSelected(this.index);
    // TODO: Fix logic as it won't work with multiple results
    // return (this.examinerLocationSelection.currentSearchResult?.LocationDistancesPilotExaminerLocationId == this.searchResult?.LocationDistancesPilotExaminerLocationId &&
    //   this.examinerLocationSelection.currentSearchResult?.LocationDistancesAirportId == this.searchResult?.LocationDistancesAirportId);
  }

  containerClick() {
    if (!this.isContainerSelected()) {
      this.scheduleSelectorService.selectDetail(this.index);
      //this.select.emit();

      // this.examinerLocationSelection.currentSearchResult = this.searchResult;
      // this.examinerLocationSelectionChange.emit(this.examinerLocationSelection);

      if (this.searchResult.AvailableTimeSlots?.length > 0) {
        this.setupInitialSelections();
      }
    }
  }

  private setupInitialSelections() {
    // this.examinerLocationDetail = this.examinerLocationSelection.details?.find((detail) => detail.searchResult == this.searchResult);

    // if (!this.examinerLocationDetail) {
    //   this.examinerLocationDetail = {
    //     scheduleDateTime: [],
    //     searchResult: this.searchResult
    //   }

    //   this.examinerLocationSelection.details.push(this.examinerLocationDetail);
    // }

    this.setupConfirmButton();

    this.setupTotalAllowed();

    if (!this.isContainerSelected()) {
      return;
    }

    if (this.allowMultipleSelect) {

      const currentCount = this.scheduleSelectorService.getSelectedCount(this.index);

      if (this.totalAllowed > 0 && currentCount == 0) {
        // If we have no selected times, then select the first available time slots
        const selectedDateTimes: any[] = [];
        for (const timeslot of this.searchResult.AvailableTimeSlots) {
          if (selectedDateTimes.length < this.totalAllowed) {
            selectedDateTimes.push(timeslot.StartDateTimeUtc);
          } else {
            break;
          }
        }
        this.selectedDateTimes = selectedDateTimes;
        this.setSelectedDateTimes(selectedDateTimes);
      }
    } else {
      //this.selectedDateTime = this.examinerLocationDetail.scheduleDateTime?.[0] || this.searchResult.AvailableTimeSlots?.[0]?.StartDateTimeUtc || '';
      this.selectedDateTime = this.lastSelectedDateTime;

      this.lastSelectedDateTime = null;

      if (!this.selectedDateTime) {
        this.selectedDateTime = this.searchResult.AvailableTimeSlots?.[0]?.StartDateTimeUtc || '';
      }

      if (this.selectedDateTime) {
        this.setSelectedDateTime(this.selectedDateTime);
      }
    }

  }

  private setupTotalAllowed() {
    this.allowMultipleSelect = this.scheduleSelectorService.examinerLocationSelection.totalAllowed > 1;

    if (!this.allowMultipleSelect) {
      // If we are only allowing one, then each click will clear the previous selection
      //  When the container is not selected, we always need to clear the selected item
      if (!this.scheduleSelectorService.isSelected(this.index)) {
        if (this.selectedDateTimes.length > 0) {
          this.selectedDateTimes = [];

          this.setSelectedDateTimes(this.selectedDateTimes);
        }
      }
    }

    this.totalAllowed = this.scheduleSelectorService.getTotalAllowed(this.index);
  }

  private setupImage() {
    this.defaultAvatarMediaUrl = this.uiConfig.defaultAvatarImageUrl;

    if (!this.searchResult) {
      return;
    }

    const mediaPath = this.searchResult.UserPictureDwroMediaMediaPath;
    if (mediaPath) {
      this.imagePath = `${this.apiRoot}/media/download/${mediaPath}`;
    }
  }

}
